// eslint-disable-next-line no-restricted-imports
import type { DeletedModel } from 'app/gamma/src/modules/sockets';
// eslint-disable-next-line no-restricted-imports
import { isDeletedModel } from 'app/gamma/src/modules/sockets';
import { convertReactionToClientFormat } from './convertReactionToClientFormat';
import { getPendingUpdateId } from './getPendingUpdateId';
import { reactionsState } from './reactionsState';
import { updateReactionInSharedState } from './updateReactionInSharedState';
import type { ReactionModel, ReactionResponse } from './Reactions.types';

export const applySocketReaction = (delta: ReactionResponse | DeletedModel) => {
  if (isDeletedModel(delta)) {
    // Find the reaction in the state and remove it, because the deleted
    // response object only provides a single reaction id we have to comb
    // through all the reaction groups to find the given reaction model.
    reactionsState.setValue({
      ...reactionsState.value,
      reactions: Object.entries(reactionsState.value.reactions).reduce<{
        [idModel: string]: ReactionModel[];
      }>((acc, [idModel, reactionGroup]) => {
        acc[idModel] = reactionGroup.filter(
          (reaction) => reaction.id !== delta.id,
        );

        return acc;
      }, {}),
    });
  } else {
    // See if the reaction has already been added to the state,
    // if it has don't add it again, if not add it the reaction group.
    const normalizedPayload = convertReactionToClientFormat(delta);

    const reactionGroup = reactionsState.value.reactions[delta.idModel] || [];
    const existingReaction =
      reactionGroup.some(
        (reaction) =>
          reaction.idEmoji.toUpperCase() ===
            normalizedPayload.idEmoji.toUpperCase() &&
          reaction.idMember === normalizedPayload.idMember,
      ) ||
      reactionsState.value.pendingUpdates[
        getPendingUpdateId(delta.idModel, delta.idEmoji, delta.idMember)
      ];

    if (existingReaction) {
      updateReactionInSharedState(normalizedPayload);
    } else {
      reactionsState.setValue({
        ...reactionsState.value,
        reactions: {
          ...reactionsState.value.reactions,
          [delta.idModel]: [
            ...(reactionsState.value.reactions[delta.idModel] || []),
            normalizedPayload,
          ],
        },
      });
    }
  }
};
